import AdminSidebar from "./AdminSidebar";
import UserSidebar from "./UserSidebar";

export default function Sidebar({ isOpen, onClose }) {

  const role = localStorage.getItem("role"); // get role from login

  if (role === "admin") {
    return <AdminSidebar isOpen={isOpen} onClose={onClose} />;
  }

  return <UserSidebar isOpen={isOpen} onClose={onClose} />;
}